(function () {
  function updateHeaderGroupHeight() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var offset = Math.round(main.getBoundingClientRect().top + window.scrollY);
    document.documentElement.style.setProperty('--header-group-height', offset + 'px');
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderGroupHeight();

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(updateHeaderGroupHeight);
      document.querySelectorAll('.utility-bar').forEach(function (utilityBar) {
        observer.observe(utilityBar);
      });
      var sectionHeader = document.querySelector('.section-header');
      if (sectionHeader) observer.observe(sectionHeader);
    }
  });
})();
